import Section from "../Section";
import Slider from "../global/Slider";

export default class Slideshow extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    if (!element) return;

    const sliderElement = element.querySelector('.slider-homepage');

    if (!sliderElement) return;

    this.hasSlides = sliderElement.querySelector('.slides');

    if (this.hasSlides) this.slider = new Slider(theme, sliderElement);
  }

    onBlockSelect = ({ element }) => {
      const index = parseInt(element.dataset.slideIndex, 10);

      if (this.hasSlides) this.slider.showSlide(index);
    }

    onBlockDeselect = () => {
      if (this.hasSlides) this.slider.startAnimation();
    }
}
